<template>
  <div class="gtp-panel">
    <div v-if="pageLoading" class="gtp-loading">
      <van-loading type="spinner" color="#8131e7" />
    </div>

    <template v-else>
      <!-- 公会长信息卡片 -->
      <div class="gtp-leader-card">
        <img
          class="gtp-leader-avatar"
          :src="leaderAvatar"
          alt=""
          @error="onAvatarError"
        />
        <div class="gtp-leader-text">
          <p class="gtp-leader-title">{{ $t("guild_transfer_to_leader") }}</p>
          <p class="gtp-leader-sub">{{ $t("guild_leader_settle_subtitle") }}</p>
        </div>
      </div>

      <div class="gtp-main">
        <div class="gtp-body">
          <p class="gtp-section-title">{{ $t("guild_settlement_input_amount") }}</p>

          <div class="gtp-input-wrap" @click="inputFocus">
            <img class="gtp-coin" src="../../assets/withdrawal_v2/$.png" alt="" />
            <span ref="measureRef" class="gtp-measure" aria-hidden="true">{{ inputValue }}</span>
            <input
              ref="inputRef"
              v-model="inputValue"
              type="text"
              inputmode="numeric"
              class="gtp-input"
              :placeholder="$t('guild_please_enter')"
              @input="changeCoin"
              @click.stop="inputFocus"
              @blur="onInputBlur"
            />
          </div>

          <p class="gtp-balance">
            {{ $t("guild_current_can_withdraw") }}
            <img src="../../assets/withdrawal_v2/$.png" alt="" />
            <span>{{ coinText }}</span>
          </p>

          <ul class="gtp-gear-box">
            <li :class="{ active: gearType === 0 }" @click="changeGearType(0)">{{ $t("guild_all") }}</li>
            <li :class="{ active: gearType === 1 }" @click="changeGearType(1)">1/2</li>
            <li :class="{ active: gearType === 2 }" @click="changeGearType(2)">1/3</li>
            <li :class="{ active: gearType === 3 }" @click="changeGearType(3)">1/4</li>
          </ul>

          <div class="gtp-page-tips">
            <p class="gtp-page-tips-title">{{ $t("guild_bind_notice_title") }}</p>
            <ul>
              <li>{{ $t("guild_leader_confirm_tip_1") }}</li>
              <li>{{ $t("guild_leader_confirm_tip_2") }}</li>
              <li>{{ $t("guild_leader_confirm_tip_3", { n: applyMinNum }) }}</li>
              <li>
                {{ $t("guild_leader_confirm_tip_4_prefix") }}
                <span class="gtp-appeal-link" @click="goPublish">
                  {{ $t("guild_leader_platform_appeal") }} >
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div class="gtp-footer">
          <button type="button" class="gtp-submit" @click="submitApply">
            {{ $t("withdraw_submit") }}
          </button>
        </div>
      </div>
    </template>

    <transfer-confirm-dialog
      :visible="showPop"
      :amount="displayAmount"
      desc-key="guild_leader_confirm_desc"
      :tips="confirmTips"
      @close="closePopup"
      @confirm="confirm"
    />

    <!-- 平台审核弹窗 -->
    <div v-if="showReviewPop" class="gtp-review-mask" @click.self.prevent>
      <div class="gtp-review-dialog" @click.stop>
        <img
          class="gtp-review-icon"
          src="../../assets/withdrawal/review-icon.png"
          alt=""
        />
        <p class="gtp-review-title">{{ $t("guild_status_platform_review") }}</p>
        <p
          class="gtp-review-subtitle"
          v-html="$t('guild_status_guild_leader_approval', { n: hour })"
        ></p>
        <button type="button" class="gtp-review-btn" @click="closeReviewPop">
          {{ $t("withdrawalLogin.Confirm") }}
        </button>
      </div>
    </div>

    <div v-if="actionLoading" class="gtp-action-loading">
      <van-loading type="spinner" color="#8131e7" />
    </div>
    <!-- 需真人认证时展示认证弹窗；关闭按钮触发 close -->
    <certification-pop
      v-if="showCertification"
      :err-code="certErrCode"
      page-source="转公会长"
      @close="showCertification = false"
    ></certification-pop>
  </div>
</template>

<script>
/**
 * 转移给公会长 v2 主面板（2026-06-08）
 * 公会长信息来自 withdraw/init；金额输入同自提现自定义（无法币）
 */
import axios from "axios";
import { Toast, Loading } from "vant";
import "vant/lib/loading/style";
import TransferConfirmDialog from "@/components/withdrawal/transfer-confirm-dialog.vue";
import CertificationPop from "@/components/withdrawal/certification_pop.vue";

const DEFAULT_AVATAR = require("../../assets/withdrawal_v2/logo.png");

export default {
  name: "guild-leader-transfer-panel",
  components: {
    TransferConfirmDialog,
    CertificationPop,
    [Loading.name]: Loading,
  },
  data() {
    return {
      pageLoading: true,
      actionLoading: false,
      /** 是否展示真人认证弹窗（transferToLeader/apply 返回 501915 时置 true） */
      showCertification: false,
      /** 触发认证弹窗的接口错误码（501915 / 501918），传给弹窗以区分 App 方法 */
      certErrCode: 0,
      inputValue: "",
      gearType: 5,
      currentCoin: 0,
      applyMinNum: 0,
      guildId: "",
      guildUid: "",
      appealToPlatformUrl: "",
      leaderInfo: {
        avatar: "",
        nickname: "",
      },
      showPop: false,
      showReviewPop: false,
      hour: "",
      token: "",
      uid: "",
      lang: "",
      deviceId: "",
    };
  },
  computed: {
    // 可转出余额的千分位展示文本
    coinText() {
      return Number(this.currentCoin || 0).toLocaleString("en-US");
    },
    // 输入框当前显示金额（经千分位格式化）
    displayAmount() {
      return this.formatInputValue(String(this.getInputNumber()));
    },
    // 公会长头像：无则用默认占位图
    leaderAvatar() {
      return this.leaderInfo.avatar || DEFAULT_AVATAR;
    },
    // 确认弹窗提示文案列表（含最小转出金额参数）
    confirmTips() {
      return [
        { key: "guild_leader_confirm_tip_1" },
        { key: "guild_leader_confirm_tip_2" },
        { key: "guild_leader_confirm_tip_3", params: { n: this.applyMinNum } },
        { key: "guild_leader_confirm_tip_4" },
      ];
    },
  },
  // 初始化：从路由参数读取余额/公会信息/最小金额/申诉链接，并拉取接口数据
  created() {
    const q = this.$route.query;
    this.currentCoin = Number(q.cin || 0);
    this.guildId = q.guildId || "";
    this.guildUid = q.guildUid || "";
    this.applyMinNum = Number(q.minCoin || 0);
    this.appealToPlatformUrl = q.toUrl || "";
    this.initAuth();
    this.initLang();
    this.fetchInitData();
  },
  methods: {
    // 从 localStorage 初始化鉴权信息；无缓存则结束加载
    initAuth() {
      const raw = localStorage.getItem("data");
      if (!raw) {
        this.pageLoading = false;
        return;
      }
      try {
        const data = JSON.parse(raw);
        this.token = data.token;
        this.uid = String(data.uid ?? data.userId ?? "");
        this.lang = data.lang || navigator.language;
        this.deviceId = data.deviceId || "";
      } catch (e) {
        /* ignore */
      }
    },
    // 初始化 i18n 语言：根据用户语言映射到支持的语言码并同步 html lang（避免刷新后显示英文）
    initLang() {
      try {
        const raw = localStorage.getItem("data");
        const data = raw ? JSON.parse(raw) : {};
        const lang = data.lang || navigator.language;
        const langs = String(lang).substring(0, 2);
        const map = { zh: "zh", en: "en", ar: "ar", tr: "tr", es: "es", pt: "pt", fr: "fr", id: "id", ms: "ms" };
        if (langs === "zh") {
          this.$i18n.locale = lang === "zh-TW" || lang === "zh-HK" ? "tc" : "zh";
        } else {
          this.$i18n.locale = map[langs] || "en";
        }
        document.querySelector("html").setAttribute("lang", this.$i18n.locale);
      } catch (e) {
        /* ignore */
      }
    },
    // 头像加载失败时替换为默认头像
    onAvatarError(e) {
      e.target.src = DEFAULT_AVATAR;
    },
    // 初始化转移数据：余额、最小金额、公会信息、公会长信息
    fetchInitData() {
      if (!this.token || !this.uid) {
        this.pageLoading = false;
        return;
      }
      this.pageLoading = true;
      axios
        .get(
          `${this.$serviceIp}api/trade/guild/withdraw/init?token=${this.token}&uid=${this.uid}`,
          {
            headers: {
              deviceId: this.deviceId,
              version: "3.0",
              lang: this.lang,
            },
          }
        )
        .then(({ data }) => {
          if (data.code === 200) {
            const payload = data.data || {};
            const guild = payload.newGuildInfoResult || {};
            // 余额：接口优先，其次保留路由参数
            this.currentCoin = payload.currentCoin || this.currentCoin;
            // 路由未传最小金额时用接口值兜底
            if (!this.applyMinNum && payload.transferToLeaderMinCoin) {
              this.applyMinNum = payload.transferToLeaderMinCoin;
            }
            // 公会 id 与 uid 接口兜底
            if (!this.guildId && guild.id) {
              this.guildId = guild.id;
            }
            if (!this.guildUid && guild.userId) {
              this.guildUid = guild.userId;
            }
            // 申诉平台链接接口兜底
            if (!this.appealToPlatformUrl && payload.appealToPlatformUrl) {
              this.appealToPlatformUrl = payload.appealToPlatformUrl;
            }
            // 组装公会长头像与昵称（leaderAvatar 为 init 接口顶层字段，优先取，其余字段兼容）
            this.leaderInfo = {
              avatar:this.$route.query.leaderAvatar ||
                "",
              nickname:
                guild.nickname ||
                guild.userName ||
                guild.name ||
                guild.guildLeaderName ||
                "",
            };
          } else {
            Toast(data.message || this.$t("transfer.error"));
          }
        })
        .catch(() => Toast(this.$t("transfer.error")))
        .finally(() => {
          this.pageLoading = false;
        });
    },
    // 千分位格式化展示金额
    formatInputValue(raw) {
      if (!raw) return "";
      return Number(raw).toLocaleString("en-US");
    },
    // 去掉千分位逗号取实际数值
    getInputNumber() {
      return Number(String(this.inputValue).replace(/,/g, "")) || 0;
    },
    // 金额输入框聚焦：光标移到末尾，档位重置为自定义
    inputFocus() {
      const input = this.$refs.inputRef;
      if (!input) return;
      this.$nextTick(() => {
        input.focus();
        const len = input.value.length;
        input.setSelectionRange(len, len);
      });
      if (this.gearType !== 5) {
        this.gearType = 5;
      }
    },
    // 失焦处理（保持内容为空）
    onInputBlur() {
      if (this.inputValue === "") {
        this.inputValue = "";
      }
    },
    // 输入金额：清洗非法字符、千分位格式化，并按文本长度自适应输入框宽度
    changeCoin() {
      const raw =
        this.inputValue.toString().replace(/[^\d]/g, "").replace(/^0+/, "") || "";
      this.inputValue = this.formatInputValue(raw);
      this.$nextTick(() => {
        const span = this.$refs.measureRef;
        const input = this.$refs.inputRef;
        if (!span || !input) return;
        let width = span.offsetWidth + 20;
        if (raw.length > 5) width += 20;
        if (raw.length > 9) width += 20;
        if (raw.length > 13) width += 20;
        input.style.width = `${Math.max(width, 40)}px`;
        const len = this.inputValue.length;
        input.setSelectionRange(len, len);
      });
    },
    // 快捷档位：全部 / 1/2 / 1/3 / 1/4，再次点击无反应（不取消选择）
    changeGearType(type) {
      this.gearType = type;
      const coin = Number(this.currentCoin || 0);
      if (type === 0) {
        this.inputValue = this.formatInputValue(String(coin));
      } else if (type === 1) {
        this.inputValue = this.formatInputValue(String(Math.floor(coin / 2)));
      } else if (type === 2) {
        this.inputValue = this.formatInputValue(String(Math.floor(coin / 3)));
      } else if (type === 3) {
        this.inputValue = this.formatInputValue(String(Math.floor(coin / 4)));
      }
      this.changeCoin();
    },
    // 提交前校验：金额必填 / 不超过余额 / 不低于最小申请额
    submitApply() {
      const amount = this.getInputNumber();
      if (!amount) {
        Toast(this.$t("guild_please_enter_amount"));
        return;
      }
      if (amount > Number(this.currentCoin)) {
        Toast(this.$t("guild_withdraw_note_2"));
        return;
      }
      if (amount < Number(this.applyMinNum)) {
        Toast(this.$t("guild_tips_1") + this.applyMinNum);
        return;
      }
      // 校验通过后弹出确认弹窗
      this.showPop = true;
    },
    // 关闭确认弹窗
    closePopup() {
      this.showPop = false;
    },
    // 关闭平台审核弹窗并返回上一页
    closeReviewPop() {
      this.showReviewPop = false;
      this.$router.go(-1);
    },
    // 打开平台申诉链接（携带语言与用户 id 参数）
    goPublish() {
      if (!this.appealToPlatformUrl) return;
      window.open(
        `${this.appealToPlatformUrl}?isShowNav=0&type=4&langType=${this.lang}&userId=${this.uid}`
      );
    },
    // 确认转移：调用 transferToLeader/apply 接口
    confirm() {
      if (this.actionLoading) return;
      this.closePopup();
      this.actionLoading = true;
      const coinNum = this.getInputNumber();
      axios({
        url: `${this.$serviceIp}api/trade/guild/withdraw/transferToLeader/apply`,
        method: "post",
        headers: {
          version: "3.0",
          deviceId: this.deviceId,
          lang: this.lang,
        },
        data: {
          guildId: this.guildId,
          guildUid: this.guildUid,
          coinNum,
        },
        params: { token: this.token, uid: this.uid },
      })
        .then((res) => {
          if (res.data.code === 200) {
            Toast(this.$t("guild_communicate_with_reseller"));
            const result = res.data.data;
            if (result && result.hour) {
              // 需要平台审核：记录审核时长并弹出审核提示
              this.hour = result.hour;
              this.showReviewPop = true;
            } else if (result) {
              // 已进入审批流程：稍后返回上一页
              setTimeout(() => this.$router.go(-1), 500);
            } else {
              // 无返回数据：刷新余额
              this.refreshBalance();
            }
            // 501912 , 501918, 501923  都归为 性别认证失败场景,需性别认证
            // 501915 需真人认证拦截
          } else if (res.data.code === 501915 || res.data.code === 501918 || res.data.code === 501912 || res.data.code === 501923) {
            // 需真人认证：展示认证弹窗（记录错误码供弹窗区分 App 方法）
            this.certErrCode = res.data.code;
            this.showCertification = true;
          } else {
            Toast(res.data.message || this.$t("transfer.error"));
          }
        })
        .catch(() => Toast(this.$t("transfer.error")))
        .finally(() => {
          this.actionLoading = false;
        });
    },
    // 刷新可提现余额并清空输入
    refreshBalance() {
      axios
        .get(
          `${this.$serviceIp}api/trade/guild/withdraw/init?token=${this.token}&uid=${this.uid}`,
          {
            headers: {
              deviceId: this.deviceId,
              version: "3.0",
              lang: this.lang,
            },
          }
        )
        .then(({ data }) => {
          if (data.code === 200) {
            this.currentCoin = data.data.currentCoin;
            this.inputValue = "";
            this.gearType = 5;
          }
        })
        .finally(() => {
          this.actionLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.gtp-panel {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding-top: 20px;
  box-sizing: border-box;
  font-family: "Montserrat", sans-serif;
}

.gtp-loading {
  display: flex;
  justify-content: center;
  padding: 80px 0;
}

.gtp-leader-card {
  display: flex;
  align-items: center;
  gap: 24px;
  flex-shrink: 0;
  width: calc(100% - 56px);
  max-width: 594px;
  margin: 0 auto 24px;
  padding: 24px;
  background: #fff;
  border-radius: 24px;
  box-sizing: border-box;
}

.gtp-leader-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background: #f5f6f8;
}

.gtp-leader-text {
  flex: 1;
  min-width: 0;
}

.gtp-leader-title {
  margin: 0 0 8px;
  font-size: 26px;
  font-weight: 600;
  color: #262427;
}

.gtp-leader-sub {
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  color: #89848d;
}

.gtp-main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  background: #fff;
  border-radius: 24px 32px 0 0;
  padding: 32px 28px calc(16px + env(safe-area-inset-bottom));
  box-sizing: border-box;
  overflow: hidden;
}

.gtp-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.gtp-section-title {
  margin: 0 0 16px;
  font-size: 24px;
  font-weight: 500;
  color: #89848d;
}

.gtp-input-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 88px;
  padding: 0 24px;
  border: 1px solid #dbdbdb;
  border-radius: 16px;
  background: #fff;
  box-sizing: border-box;
}

.gtp-coin {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
}

.gtp-measure {
  position: absolute;
  visibility: hidden;
  white-space: pre;
  font-size: 28px;
  font-family: "Mada", sans-serif;
  top: -9999px;
  left: -9999px;
}

.gtp-input {
  flex: 1;
  min-width: 40px;
  border: none;
  outline: none;
  background: transparent;
  font-size: 28px;
  font-weight: 500;
  color: #262427;
}

.gtp-input::placeholder {
  color: #c4c0c8;
  font-weight: 400;
}

.gtp-balance {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 24px 0 5px;
  font-size: 24px;
  font-weight: 400;
  color: #262427;
}

.gtp-balance img {
  width: 36px;
  height: 36px;
}

.gtp-balance span {
  font-size: 26px;
}

.gtp-gear-box {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin: 0 0 24px;
  padding: 0;
  list-style: none;
}

.gtp-gear-box li {
  height: 64px;
  border: 1px solid #DFD9E3;
  border-radius: 32px;
  font-size: 24px;
  line-height: 64px;
  color: #DFD9E3;
  text-align: center;
  padding: 0 40px;
}

.gtp-gear-box li.active {
  color: #8131e7;
  border-color: #8131e7;
}

.gtp-page-tips {
  padding: 20px 24px;
  border-radius: 16px;
  background: linear-gradient(
    360deg,
    rgba(255, 147, 147, 0) 0%,
    rgba(255, 147, 147, 0.25) 100%
  );
  font-size: 22px;
  line-height: 34px;
  color: #262427;
}

.gtp-page-tips-title {
  margin: 0 0 20px;
  font-size: 24px;
  font-weight: 500;
  color: #ff4365;
}

.gtp-page-tips-title::before {
  display: inline-block;
  content: "";
  width: 32px;
  height: 32px;
  background: url("../../assets/withdrawal_v2/elert.png") no-repeat;
  background-size: 100% 100%;
  vertical-align: top;
  margin-right: 8px;
}

.gtp-page-tips ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.gtp-page-tips li {
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 20px;
  padding-left: 1em;
  text-indent: -1em;
}

.gtp-page-tips li:last-child {
  margin-bottom: 0;
}

.gtp-appeal-link {
  color: #7b4dff;
}

.gtp-footer {
  flex-shrink: 0;
  margin-top: auto;
  padding-top: 24px;
  display: flex;
  justify-content: center;
}

.gtp-submit {
  width: 100%;
  max-width: 412px;
  height: 80px;
  border: none;
  border-radius: 40px;
  background: #8131e7;
  font-size: 24px;
  font-weight: 500;
  color: #fff;
}

.gtp-review-mask {
  position: fixed;
  inset: 0;
  z-index: 400;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 48px;
  box-sizing: border-box;
}

.gtp-review-dialog {
  position: relative;
  width: 100%;
  max-width: 530px;
  background: linear-gradient(0deg, #fff 0%, #ecebff 100%);
  border-radius: 24px;
  padding: 96px 48px 48px;
  box-sizing: border-box;
  text-align: center;
}

.gtp-review-icon {
  width: 196px;
  height: 196px;
  position: absolute;
  top: -90px;
  left: 50%;
  transform: translateX(-50%);
}

.gtp-review-title {
  margin: 0 0 16px;
  font-size: 26px;
  font-weight: 500;
  color: #1f1315;
}

.gtp-review-subtitle {
  margin: 0 0 32px;
  font-size: 24px;
  line-height: 1.3;
  color: #262427;
}

.gtp-review-subtitle >>> span {
  color: #8131e7;
  font-weight: 700;
}

.gtp-review-btn {
  width: 218px;
  height: 64px;
  border: none;
  border-radius: 100px;
  background: #8131e7;
  font-size: 28px;
  font-weight: 500;
  color: #fff;
}

.gtp-action-loading {
  position: fixed;
  inset: 0;
  z-index: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.4);
}

html[lang="ar"] .gtp-panel,
html[lang="ar"] .gtp-main {
  direction: rtl;
}

html[lang="ar"] .gtp-page-tips-title::before {
  margin-right: 0;
  margin-left: 8px;
}
</style>
